import React, { useEffect, useState, useRef } from 'react';
import { testAPI, useTypes } from '../../hooks/useSupportingArticle';
import authApi from '../../apis/authApi';
import axios from 'axios';

import { Modal, Form, Select, Button, Input, Upload, Checkbox, Tag, Space, notification, Popconfirm } from 'antd';
import useStudios, { fetchAllStudios, useListingStudios } from '../../hooks/useStudios';
import { GetImageUploadURL, PostSupportingArticle } from '../../hooks/useCreation';
import { useCompanies, useListingCompanies } from '../../hooks/useCompanies';
import useLogout from '../../hooks/useLogout';
import { useQuery } from 'react-query';
import { v4 as uuidv4 } from 'uuid';
import arrowLeft from '../../../src/assets/images/arrowLeft.png';
import { useNavigate } from 'react-router-dom';
import { DeleteOutlined, StopOutlined } from '@ant-design/icons';
import forKids from '../../assets/images/gender_kids.png';
import forFemales from '../../assets/images/gender_female.png';
import forMales from '../../assets/images/gender_male.png';
import forUnisex from '../../assets/images/gender_unisex.png';

import { useUpdateSupportingArticle } from '../../hooks/useSupportingArticle';

const productTags = {
    Gender: '',
    Size: '',
    Color: '',
};

const EditSupportingArticles = ({ selectedStudioTags, refetchSupportingArticles, closeEditModal, onUpdateArticleSuccess }) => {
    const [reqBody, setReqBody] = useState({});
    const { logout } = useLogout();
    const [api, contextHolder] = notification.useNotification();
    const [keyValueTags, setKeyValueTags] = useState([]);

    const { mutate: updateSupportingArticle } = useUpdateSupportingArticle(onUpdateArticleSuccess);
    useEffect(() => {
        if (selectedStudioTags?.productTags) {
            const newArray1 = Object.keys(selectedStudioTags?.productTags).map(key => ({
                value: selectedStudioTags?.productTags?.[key],
                key: key,
                id: uuidv4(),
            }));
            console.log('newArray1: ', newArray1);
            setKeyValueTags(newArray1);
        } else {
            const newArray2 = Object.keys(productTags).map(key => ({
                value: '',
                key: key,
                id: uuidv4(),
            }));
            setKeyValueTags(newArray2);
        }
    }, []);

    const getkeyValueTags = () => {
        let items = [...keyValueTags];
        let returnableItem = {};
        items.forEach(item => {
            returnableItem[item?.key] = item?.value;
        });
        return returnableItem;
    };

    const handleRemoveProductTag = id => {
        let items = [...keyValueTags];
        let filteredItems = items?.filter(item => item?.id !== id);
        setKeyValueTags(filteredItems);
    };

    const handleKeyValueChange = (e, item, tag) => {
        let val = e?.target?.value;
        console.log('===>', e);
        let items = [...keyValueTags];
        let indexOfItem = items?.findIndex(elm => elm?.id === item?.id);
        if (tag === 'tagName') {
            items[indexOfItem] = { ...item, key: val };
        }
        if (tag === 'tagValue') {
            items[indexOfItem] = { ...item, value: val };
        }
        setKeyValueTags([...items]);
    };

    const checkForProductTags = () => {
        let items = [...keyValueTags];
        let filteredItem = items.filter(item => ['size', 'gender', 'color'].includes(item?.key.toLowerCase()));
        let disabled = false;
        for (let item of filteredItem) {
            if (item?.value === '') {
                disabled = true;
            }
        }
        for (let item of items) {
            if (item?.key === '' || item?.value === '') {
                disabled = true;
            }
        }
        return disabled;
    };

    const handleSubmitEditing = async () => {
        const bodyObj = reqBody;
        bodyObj['productTags'] = getkeyValueTags();
        bodyObj['id'] = selectedStudioTags?._id;
        updateSupportingArticle(bodyObj);
    };
    const getGenderOptions = () => {
        let retrunableOptions = [
            {
                label: (
                    <div>
                        <img src={forMales} alt="gender_man" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Male
                    </div>
                ),
                value: 'Male',
            },
            {
                label: (
                    <div>
                        <img src={forFemales} alt="gender_woman" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Female
                    </div>
                ),
                value: 'Female',
            },
            {
                label: (
                    <div>
                        <img src={forUnisex} alt="gender_unisex" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Unisex
                    </div>
                ),
                value: 'Unisex',
            },
            {
                label: (
                    <div>
                        <img src={forKids} alt="gender_kids" style={{ width: '13px', height: '13px', marginRight: '5px' }} />
                        Kids
                    </div>
                ),
                value: 'Kids',
            },
        ];
        return retrunableOptions;
    };

    return (
        <>
            <div
            // style={{
            //     display: 'flex',
            //     justifyContent: 'center',
            //     alignItems: 'center',
            // }}
            >
                {contextHolder}
                <h3>Edit Supporting Article: Product Tags</h3>

                <Form
                    // wrapperCol={{
                    //     span: 15,
                    // }}
                    // layout="horizontal"
                    style={{
                        maxWidth: 800,
                        border: '1px solid grey',
                        padding: '20px',
                        borderRadius: '10px',
                        margin: '10px',
                    }}
                >
                    <Form.Item>
                        <Space direction="horizontal" align="start">
                            <Space direction="vertical">
                                {keyValueTags.map((item, index) => {
                                    return (
                                        <Space direction="horizontal" key={index}>
                                            <Input
                                                placeholder="Tag name"
                                                allowClear
                                                enterButton="Add"
                                                size="large"
                                                value={item?.key}
                                                onChange={e => handleKeyValueChange(e, item, 'tagName')}
                                                disabled={['size', 'gender', 'color'].includes(item?.key.toLowerCase())}
                                            />
                                            {item?.key === 'Gender' ? (
                                                <Select
                                                    value={item?.value || null}
                                                    enterButton="Add"
                                                    size="large"
                                                    onChange={val => handleKeyValueChange({ target: { value: val } }, item, 'tagValue')}
                                                    options={getGenderOptions()}
                                                    style={{
                                                        width: '13.8rem',
                                                    }}
                                                    placeholder="Tag value"
                                                />
                                            ) : (
                                                <Input
                                                    placeholder="Tag value"
                                                    allowClear
                                                    enterButton="Add"
                                                    size="large"
                                                    value={item?.value}
                                                    onChange={e => handleKeyValueChange(e, item, 'tagValue')}
                                                />
                                            )}
                                            {['size', 'gender', 'color'].includes(item?.key.toLowerCase()) ? (
                                                <Button
                                                    type="text"
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    disabled
                                                >
                                                    <DeleteOutlined />
                                                </Button>
                                            ) : (
                                                <Button
                                                    type="text"
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                    }}
                                                    onClick={() => handleRemoveProductTag(item?.id)}
                                                >
                                                    <DeleteOutlined />
                                                </Button>
                                            )}
                                        </Space>
                                    );
                                })}
                            </Space>
                            <Space direction="vertical" align="start">
                                <Button
                                    style={{ width: 100 }}
                                    onClick={e =>
                                        setKeyValueTags(prev => [
                                            ...prev,
                                            {
                                                id: uuidv4(),
                                                key: '',
                                                value: '',
                                            },
                                        ])
                                    }
                                >
                                    + Add more
                                </Button>
                            </Space>
                        </Space>
                    </Form.Item>

                    <Form.Item label="">
                        <Popconfirm
                            title="Update product tags"
                            description="Are you sure you want to update product tags? Existing Tags would be overwritten."
                            onConfirm={handleSubmitEditing}
                            onCancel={() => {}}
                            okText="Yes"
                            cancelText="No"
                            disabled={checkForProductTags()}
                        >
                            <Button disabled={checkForProductTags()}>Update</Button>
                        </Popconfirm>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

export default EditSupportingArticles;
